import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Select from "react-select";
import CurrencyConverter from "../../Currency/CurrencyConverter";

const EpinFilter = ({ selectedOptions, setSelectedOptions, partials, setCurrentPage }) => {
  const { t } = useTranslation();
  const listOptions = [];
  const amountOptions = []
  const [epinSearch, setEpinSearch] = useState(selectedOptions.epin);
  const [amount, setAmount] = useState([]);
  const [status, setStatus] = useState([]);

  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );

  const handleEpinSearchChange = (event) => {
    setEpinSearch(event.target.value);
  };

  const handleAmountChange = (selectedOption) => {
    setAmount(selectedOption);
  };

  const handleStatusChange = (selectedOption) => {
    setStatus(selectedOption);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setSelectedOptions({
      ...selectedOptions,
      selectedAmountOption: amount.map((option) => option.value),
      selectedStatusOption: status.map((option) => option.value),
      epin: epinSearch,
    });
  };

  const handleReset = () => {
    setCurrentPage(1);
    setSelectedOptions({
      epin: "",
      selectedAmountOption: "",
      selectedStatusOption: "",
    });
    setAmount([]);
    setStatus([]);
    setEpinSearch("");
  };

  // Adding lang to the category
  partials?.status?.map((item) => {
    const data = {
      label: t(`${item.label}`),
      value: item.value,
    };
    listOptions.push(data);
  });

  partials?.amounts.map((item)=> {
    const data = {
      label: CurrencyConverter(item.label, conversionFactor),
      // value: CurrencyConverter(item.value, conversionFactor)
      value: item.value

    }
    amountOptions.push(data)
  })

  return (  
    <div className="filter_Section">
      <div className="row align-items-center">
        <div className="col-md-2">
          <div className="right_search_div">
            <label htmlFor="epinSearch">{t("epin")}</label>
            <input
              id="epinSearch"
              type="text"
              value={epinSearch}
              className="form-control"
              placeholder="E-pin"
              onChange={handleEpinSearchChange}
            />
          </div>
        </div>
        {/* <div className="col-md-2">
          <div className="right_search_div">
            <label htmlFor="amount">{t("amount")}</label>
            <Select
              id="amount"
              value={amount}
              onChange={handleAmountChange}
              options={amountOptions}
              isMulti
            />
          </div>
        </div> */}
        <div className="col-md-2">
          <div className="right_search_div">
            <label htmlFor="status">{t("status")}</label>
            <Select
              id="status"
              value={status}
              onChange={handleStatusChange}
              options={listOptions}
              isMulti
            />
          </div>
        </div>
        <div className="col-md-2 mt-4">
          <div className="right_search_div d-flex gap-1">
            <button className="btn btn-primary" onClick={handleSearch}>
              {t("search")}
            </button>
            <button className="btn btn-secondary" onClick={handleReset}>
              {t("reset")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpinFilter;
